import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
  dialogPaper: { maxHeight: 500 },
}));

const RecentChanges = (props) => {
  const classes = useStyles();
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} scroll='paper' classes={{ paper: classes.dialogPaper }}>
      <DialogTitle>آخرین تغییرات</DialogTitle>
      <DialogContent>
        <Typography variant='subtitle1'>نسخه ۲.۰‍.۱</Typography>
        <Typography variant='subtitle1'>-تغییرات متنی در صفحه چاپی</Typography>
        <Typography variant='subtitle1'>-پایان امکان حذف ارزیابی</Typography>
        {/* <Typography variant='subtitle1'>-تغییر گزینه پیشفرض چاپ به رسم</Typography> */}
        <br />
        <Typography variant='subtitle1'>نسخه ۲.۰</Typography>
        <Typography variant='subtitle1'>-باز طراحی پنل</Typography>
        <Typography variant='subtitle1'>-امکان ویرایش پیام ها</Typography>
        <Typography variant='subtitle1'>-افزوده شدن نقشه برای صفحه چاپی</Typography>
        <Typography variant='subtitle1'>-بهبود تجربه کاربر جهت ایجاد و ویرایش ارزیابی</Typography>
        <Typography variant='subtitle1'>-محدود سازی مدت ویرایش ارزیابی به دو روز</Typography>
        <Typography variant='subtitle1'>-نمایش تاریخچه ارزیابی بر اساس کد پستی</Typography>
        <Typography variant='subtitle1'>-انتخاب بین چاپ نقشه یا کروکی در صفحه ارزیابی</Typography>
        <Typography variant='subtitle1'>-باز کردن فیلد نوع ارزیابی جهت ورود متن اضافه</Typography>
        <Typography variant='subtitle1'>-فیلتر های لیست ارزیابی جهت جستجوی دقیق تر</Typography>
        <Typography variant='subtitle1'>-قابل ویرایش بودن تک تک اشیاء در ویرایشگر کروکی</Typography>
        <Typography variant='subtitle1'>-و...</Typography>
        <br />
        <Typography variant='subtitle1'>نسخه ۱.۲</Typography>
        <Typography variant='subtitle1'>-نمایش ارزیابی تکراری با کد پستی</Typography>
        <Typography variant='subtitle1'>-نمایش ۸ امتیاز در چاپ</Typography>
        <Typography variant='subtitle1'>-افزایش فیلد توضیحات به ۴۵ کاراکتر</Typography>
        <Typography variant='subtitle1'>-رفع مشکل ارزیابی های من</Typography>
        <Typography variant='subtitle1'>-رفع مشکل باز نشدن در تب جدید</Typography>
        <br />
        <Typography variant='subtitle1'>نسخه ۱.۱</Typography>
        <Typography variant='subtitle1'>-طراحی جدید و رسمی تر پنل</Typography>
        <Typography variant='subtitle1'>-تجربه کاربری بهتر</Typography>
        <Typography variant='subtitle1'>-کارایی بهتر نمایش لیست ارزیابی ها</Typography>
        <Typography variant='subtitle1'>-بهبود صفحه بندی ارزیابی ها</Typography>
        <Typography variant='subtitle1'>-حذف و بازگشت امن تر در صفحه ارزیابی ها</Typography>
        <Typography variant='subtitle1'>-نمایش ارزیابی ها و پیام های جدید</Typography>
        <Typography variant='subtitle1'>-غیر اجباری شدن برخی از فیلد های ارزیابی</Typography>
        <Typography variant='subtitle1'>-بهبود کارایی پنل</Typography>
        <Typography variant='subtitle1'>-رفع مشکلات دیگر</Typography>
        <br />
        <Typography variant='subtitle1'>نسخه ۱.۰</Typography>
        <Typography variant='subtitle1'>-انتشار رسمی پنل</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>بستن</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecentChanges;
